import React, { useState, useEffect } from 'react';
import Geocode from 'react-geocode';
import GoogleMapReact from 'google-map-react';

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey('AIzaSyBWcfuO7qKfWM6f4V1AtFKoMmwL7KttqBc');

// set response language. Defaults to english.
Geocode.setLanguage('en');

function getAddress(): void {
  // Get latitude & longitude from address.
  Geocode.fromAddress('5522 Raleigh Street, Pittsburgh, PA, 15217').then(
    (response: any) => {
      const { lat, lng } = response.results[0].geometry.location;
      console.log(lat, lng);
    },
    (error: any) => {
      console.error(error);
    }
  );
}

interface Props {
  lat: number
  lng: number
  text: string
}

interface Drone {
  id: number
  drone_name: string
  location: {
    lat: number
    lng: number
  }
  current_delivery?: {
    destination: {
      lat: number
      lng: number
    }
    status: string
    route: {
      time_start: string
      time_arrive: string
      time_return: string
    }
  }
  battery: {
    capacity: number
    charge: number
  }
}

const home: Props = {
  lat: 40.434489,
  lng: -79.9267,
  text: 'home'
}

const callDroneAPI = async (id: number): Promise<Drone> => {
  const response = await fetch('https://soarin-donuts-backend.fly.dev/drone/' + id.toString());
  const data = await response.json();
  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  const res: Drone = data;
  return res;
};

const callDroneSendAPI = async (id: number, lat: number, lon: number): Promise<number> => {
  const requestOptions = {
    method: 'PUT'
  };
  const response = await fetch('https://soarin-donuts-backend.fly.dev/api/drones/' + id.toString() + '/' + lat.toString() + '/' + lon.toString() + '/send', requestOptions);
  // const data = await response.json();

  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  // if (response.status === 200) {
  //   throw new Error('Drone not docked');
  // }
  console.log('data: ', response);
  return response.status;
};

const AnyReactComponent: React.FC<Props> = ({ lat, lng, text }: Props) =>
  <div style={{
    backgroundColor: 'yellow',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold'
  }}>{text}
  </div>;

let g: Drone[] = [];

function logDrone(): void {
  callDroneAPI(g[0].id)
    .then(data => {
      console.log(data);
    })
    .catch(error => {
      console.error(error);
    });
}

function initDrones(): void {
  g = [];
  for (let i: number = 13; i < 17; i++) {
    callDroneAPI(i)
      .then(data => {
        g.push(data);
      })
      .catch(error => {
        console.error(error);
      })
  }
}
initDrones();

function getFreeDrone(drones: Drone[]): Drone {
  for (let i: number = 0; i < drones.length; i++) {
    if (drones[i].current_delivery == null ||
      drones[i].current_delivery?.status !== 'in_route') {
      return drones[i];
    }
  }
  return null as unknown as Drone;
}

const MyComponent: React.FC = () => {
  // getAddress();
  // logDrone();
  const [markers, setMarkers] = useState<Drone[]>(g);
  const [freeDrone, setFreeDrone] = useState<string>('None');
  const [sendDrone, setSendDrone] = useState<string>('');
  const updateFreeDrone = (p: any): void => {
    const res: Drone = getFreeDrone(markers);
    if (res == null) {
      setFreeDrone('None');
    } else {
      setFreeDrone(res.id.toString());
    }
  }

  useEffect(() => {
    const intervalId = setInterval(() => { // ADDED
      async function updateMarkers(): Promise<Drone[]> {
        const updatedArray = await Promise.all(
          markers.map(async (item: Drone) => {
            const updatedItem = await callDroneAPI(item.id);
            return updatedItem;
          })
        );
        return updatedArray;
      }

      updateMarkers()
        .then((data) => {
          setMarkers(data);
        })
        .catch((error) => {
          console.error(error);
        });
    }, 1000); // ADDED
    return () => { clearInterval(intervalId) }; // ADDED
  }, []);

  function sendFreeDrone(id: string, lat: number, lng: number): void {
    // Get latitude & longitude from address.
    console.log('sending!');
    async function sendToAddress(): Promise<number> {
      const status = await callDroneSendAPI(Number(id), lat, lng);
      return status;
    }
    sendToAddress()
      .then(data => {
        if (data === 204) {
          setSendDrone('sending!');
        } else if (data === 200) {
          setSendDrone('drone is not docked. get new drone');
        } else {
          setSendDrone('error');
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
  // console.log(markers);
  return (
    <div>
      <div style={{ height: '400px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyBWcfuO7qKfWM6f4V1AtFKoMmwL7KttqBc' }}
          defaultCenter={{ lat: 40.434, lng: -79.92967 }}
          defaultZoom={13}
        >
          {markers.map((marker, index) => (
            <AnyReactComponent key={index} lat={marker.location.lat} lng={marker.location.lng} text={marker.id.toString()} />
          ))}
        </GoogleMapReact>
      </div >
    </div>
  );
}

export default MyComponent;
